var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('basic-page',{staticClass:"cookie-policy",attrs:{"addedclass":"white-bg","pagedata":this.pageData,"bannerimg":_vm.backgroundImage}},[_c('div',{staticClass:"container-espe white-bg"},[_c('h2',[_vm._v("Work in progress ...")])])])}
var staticRenderFns = []

export { render, staticRenderFns }